import { Injectable } from '@angular/core';
import { ApiVersions } from './api-version';
import { BaseService } from './base.service';
import { IAddressModel } from 'src/app/people/models/addressModel';
import { DemographicInfo } from 'src/app/people/models/demographicInfo';

@Injectable({
  providedIn: 'root',
})
export class AddressService extends BaseService {
  constructor() {
    super();
  }

  public validate = (
    address: IAddressModel,
    addressValidationCacheKey: string
  ): Promise<IAddressValidationResult> =>
    this.post(
      'address/validate',
      { ...address, addressValidationCacheKey: addressValidationCacheKey },
      null,
      ApiVersions.unversioned
    ).toPromise<IAddressValidationResult>();

  /** if addressValidationCacheKey set, will validate the address
   * @param {string} addressValidationCacheKey if set will validate address */
  public save = (
    personId: string,
    address: IAddressModel,
    addressValidationCacheKey: string
  ): Promise<DemographicInfo> =>
    this.post(
      `users/${personId}/demographicInfo/address`,
      { ...address, addressValidationCacheKey: addressValidationCacheKey },
      null,
      ApiVersions.v0_1
    )
      .toPromise()
      .then((json) => new DemographicInfo(json));
}
export type AddressValidationStatus = 'Success' | 'Warning' | 'Error';
export interface IAddressValidationResult {
  status: AddressValidationStatus;
  message: string;
  correctedAddress: IAddressModel;
  addressValidationCacheKey: string;
}
